import { Component } from '@angular/core';
import { FlexModule } from '@angular/flex-layout/flex';
import { Dir } from '@angular/cdk/bidi';
import { RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'mfa-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [FlexModule, Dir, RouterOutlet]
})
export class AppComponent {
  title = 'safemfa-web';

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIconSet(
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/mdi.svg')
    );
  }
}
